import styled from 'styled-components';

import { ModalHeading } from 'components/modal';

import { ModalContent } from '../styled';

import {
  HEADER_TOP_PADDING,
  IMAGE_BACKGROUND_COLOR,
  IMAGE_WIDTH,
} from './checking-availability-constants';

export const Container = styled(ModalContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledModalHeader = styled(ModalHeading)`
  margin: 0 auto 1rem;
  font-size: 2rem;
  line-height: 2rem;
  padding-bottom: 0px;
  border-bottom: 0px;
  ${Styles.desktop`
    padding-top: ${HEADER_TOP_PADDING};
  `}
`;

export const LoadingText = styled.p`
  text-align: center;
  font-size: 0.9375rem;
  line-height: 1.33;
  font-family: ${Styles.fontFamily.body};
  padding: 0.4375rem 2.5rem;
`;

export const LoadingGraphicWrapper = styled.div`
  height: 15rem;
  width: 15rem;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 16px;
  background: ${IMAGE_BACKGROUND_COLOR};
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
`;

export const LoadingGraphic = styled.img`
  width: ${IMAGE_WIDTH};
  ${Styles.desktop`
    width: 13rem;
  `}
  justify-self: center;
`;

export const GraphicTextWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
`;
